// import React from "react";
// import FooterComponent from "../../component/FooterComponent";
// import { RoundError } from "../../svg";
// import { useNavigate } from "react-router-dom";



// // const PaymentFailed = () => {

// //     const navigate=useNavigate()

// //   const styles = {
// //     container: {
// //       fontFamily: "'Arial', sans-serif",
// //       display: "flex",
// //       flexDirection: "column",
// //       alignItems: "center",
// //       justifyContent: "center",
// //       textAlign: "center",
// //       backgroundColor: "#FFFFFF",
// //       color: "#1D2026",
// //       height: "100vh",
// //       padding: "20px",
// //     },
// //     contentWrapper: {
// //       border: "1px solid #D3D3D3",
// //       borderRadius: "8px",
// //       padding: "20px",
// //       width: "600px",
// //       maxWidth: "100%",
// //       boxSizing: "border-box",
// //       // backgroundColor:"red"
// //     },
// //     icon: {
// //       fontSize: "50px",
// //       color: "#DC3545",
// //       marginBottom: "10px",
// //     },
// //     title: {
// //       fontSize: "24px",
// //       fontWeight: "bold",
// //       color: "#DC3545",
// //       marginBottom: "10px",
// //     },
// //     message: {
// //       fontSize: "15px",
// //       color: "#6E7485",
// //       marginBottom: "20px",
// //       lineHeight: "1.5", 
// //       whiteSpace: "normal", 
// //     },
// //     divider: {
// //       width: "100%",
// //       height: "1px",
// //       backgroundColor: "#D3D3D3",
// //       marginTop: "40px",
// //     },
// //     bankDetailsContainer: {
// //       textAlign: "left",
// //       paddingTop: "40px",
// //       marginBottom: "20px",
// //     },
// //     bankDetailsHeading: {
// //       fontSize: "18px",
// //       fontWeight: "bold",
// //       marginBottom: "20px",
// //     },
// //     detailRow: {
// //       display: "flex",
// //       justifyContent: "space-between",
// //       fontSize: "16px",
// //       marginBottom: "20px",
// //     },
// //     label: {
// //       color: "#6E7485",
// //     },
// //     value: {
// //       color: "#000000",
// //     },
// //     button: {
// //       fontSize: "18px",
// //       color: "#FFFFFF",
// //       backgroundColor: "#007BFF",
// //       border: "none",
// //       padding: "15px 30px",
// //       borderRadius: "4px",
// //       cursor: "pointer",
// //       textDecoration: "none",
// //       marginTop: "20px",
// //       transition: "background-color 0.3s",
// //     },
// //     buttonContainer: {
// //       display: "flex",
// //       justifyContent: "center",
// //       gap: "20px", // Space between buttons
// //       width: "100%",
// //       marginTop: "20px",
// //     },
// //     "@media (max-width: 1024px)": {
// //       contentWrapper: {
// //         width: "80%",
// //       },
// //       title: {
// //         fontSize: "22px",
// //       },
// //       message: {
// //         fontSize: "15px",
// //       },
// //       button: {
// //         padding: "13px 28px",
// //         fontSize: "17px",
// //       },
      
// //     },
// //     "@media (max-width: 768px)": {
// //       contentWrapper: {
// //         width: "90%",
// //       },
// //       title: {
// //         fontSize: "20px",
// //       },
// //       message: {
// //         fontSize: "14px",
// //       },
// //       button: {
// //         padding: "12px 25px",
// //         fontSize: "16px",
// //       },
// //     },
// //     "@media (max-width: 480px)": {
// //       container: {
// //         padding: "10px",
// //       },
// //       contentWrapper: {
// //         padding: "15px",
// //       },
// //       title: {
// //         fontSize: "18px",
// //       },
// //       message: {
// //         fontSize: "14px",
// //       },
// //       button: {
// //         // padding: "10px 20px",
// //         // fontSize: "14px",
// //         width: "100%",
// //       marginBottom: "10px",
// //       },
// //       buttonContainer: {
// //         flexDirection: "column",
// //         alignItems: "center",
// //       },
// //     },
// //   };

// //   return (
// //     <>
// //     <div style={styles.container}>
// //       <div style={styles.contentWrapper}>
// //         <div style={styles.icon}>

// //             <RoundError/>
// //         </div>
// //         <div style={styles.title}>PAYMENT FAILED</div>
// //         <p style={styles.message}>
// //           Unable to complete your transaction due to a technical issue! Please try again using another form of payment as the bank details of the seller are given below.
// //         </p>
// //         <div style={styles.divider}></div>
// //         <div style={styles.bankDetailsContainer}>
// //           <div style={styles.bankDetailsHeading}>Bank details</div>
// //           <div style={styles.detailRow}>
// //             <span style={styles.label}>Account number</span>
// //             <span style={styles.value}>56481254789412</span>
// //           </div>
// //           <div style={styles.detailRow}>
// //             <span style={styles.label}>Holder name</span>
// //             <span style={styles.value}>Kingster</span>
// //           </div>
// //           <div style={styles.detailRow}>
// //             <span style={styles.label}>Bank name</span>
// //             <span style={styles.value}>State Bank of India</span>
// //           </div>
// //           <div style={styles.detailRow}>
// //             <span style={styles.label}>IFSC Code</span>
// //             <span style={styles.value}>SBI0000</span>
// //           </div>
// //         </div>
// //       </div>
     
// //       <div style={styles.buttonContainer}>
// //   <a
// //     href="/courses/Courses"
// //     style={styles.button}
// //     onMouseOver={(e) => (e.target.style.backgroundColor = "#000000")}
// //     onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
// //   >
// //     Back To Home
// //   </a>

// //   <a
// //     href="/courses/Courses"
// //     style={styles.button}
// //     onMouseOver={(e) => (e.target.style.backgroundColor = "#000000")}
// //     onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
// //   >
// //     Try Again
// //   </a>
// // </div>


      
// //     </div>
// //     <FooterComponent/>
// //     </>
// //   );
// // };

// // export default PaymentFailed;
// const PaymentFailed = () => {
//   const navigate = useNavigate();

//   const styles = {
//     container: {
//       fontFamily: "'Arial', sans-serif",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       textAlign: "center",
//       backgroundColor: "#FFFFFF",
//       color: "#1D2026",
//       height: "100vh",
//       padding: "20px",
//     },
//     contentWrapper: {
//       border: "1px solid #D3D3D3",
//       borderRadius: "8px",
//       padding: "20px",
//       width: "600px",
//       maxWidth: "100%",
//       boxSizing: "border-box",
//     },
//     icon: {
//       fontSize: "50px",
//       color: "#DC3545",
//       marginBottom: "10px",
//     },
//     title: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#DC3545",
//       marginBottom: "10px",
//     },
//     message: {
//       fontSize: "15px",
//       color: "#6E7485",
//       marginBottom: "20px",
//       lineHeight: "1.5",
//       whiteSpace: "normal",
//     },
//     divider: {
//       width: "100%",
//       height: "1px",
//       backgroundColor: "#D3D3D3",
//       marginTop: "40px",
//     },
//     bankDetailsContainer: {
//       textAlign: "left",
//       paddingTop: "40px",
//       marginBottom: "20px",
//     },
//     bankDetailsHeading: {
//       fontSize: "18px",
//       fontWeight: "bold",
//       marginBottom: "20px",
//     },
//     detailRow: {
//       display: "flex",
//       justifyContent: "space-between",
//       fontSize: "16px",
//       marginBottom: "20px",
//     },
//     label: {
//       color: "#6E7485",
//     },
//     value: {
//       color: "#000000",
//     },
//     buttonContainer: {
//       display: "flex",
//       justifyContent: "space-between",
//       width: "100%",
//       maxWidth: "600px",
//       marginTop: "20px",
//     },
//     button: {
//       flex: 1,
//       fontSize: "18px",
//       color: "#FFFFFF",
//       border: "none",
//       padding: "15px",
//       borderRadius: "4px",
//       cursor: "pointer",
//       textDecoration: "none",
//       margin: "0 10px", // Spacing between buttons
//       transition: "background-color 0.3s",
//       textAlign: "center",
//     },
//     buttonPrimary: {
//       backgroundColor: "#007BFF",
//     },
//     buttonSecondary: {
//       backgroundColor: "#28A745", // A distinct green color for "Try Again"
//     },
//     "@media (max-width: 768px)": {
//       contentWrapper: {
//         width: "90%",
//       },
//       buttonContainer: {
//         flexDirection: "column",
//         alignItems: "center",
//       },
//       button: {
//         margin: "10px 0", // Space between buttons in column layout
//       },
//     },
//     "@media (max-width: 480px)": {
//       container: {
//         padding: "10px",
//       },
//       contentWrapper: {
//         padding: "15px",
//       },
//       title: {
//         fontSize: "18px",
//       },
//       message: {
//         fontSize: "14px",
//       },
//       button: {
//         // padding: "10px 20px",
//         // fontSize: "14px",
//         width: "100%",
//       marginBottom: "10px",
//       },
//       buttonContainer: {
//         flexDirection: "column",
//         alignItems: "center",
//       },
//     },
//   };
//   ;

//   return (
//     <>
//       <div style={styles.container}>
//         <div style={styles.contentWrapper}>
//           <div style={styles.icon}>
//             <RoundError />
//           </div>
//           <div style={styles.title}>PAYMENT FAILED</div>
//           <p style={styles.message}>
//             Unable to complete your transaction due to a technical issue! Please try again using another form of payment as the bank details of the seller are given below.
//           </p>
//           <div style={styles.divider}></div>
//           <div style={styles.bankDetailsContainer}>
//             <div style={styles.bankDetailsHeading}>Bank details</div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Account number</span>
//               <span style={styles.value}>56481254789412</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Holder name</span>
//               <span style={styles.value}>Kingster</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>Bank name</span>
//               <span style={styles.value}>State Bank of India</span>
//             </div>
//             <div style={styles.detailRow}>
//               <span style={styles.label}>IFSC Code</span>
//               <span style={styles.value}>SBI0000</span>
//             </div>
//           </div>
//         </div>

//         <div style={styles.buttonContainer}>
//           <a
//             href="/courses/Courses"
//             style={{ ...styles.button, ...styles.buttonPrimary }}
//             onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
//             onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
//           >
//             Back To Home
//           </a>

//           <a
//             href="/courses/Courses"
//             style={{ ...styles.button, ...styles.buttonSecondary }}
//             onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
//             onMouseOut={(e) => (e.target.style.backgroundColor = "#28A745")}
//           >
//             Try Again
//           </a>
//         </div>
//       </div>
//       <FooterComponent />
//     </>
//   );
// };

// export default PaymentFailed;


// // import React from "react";
// // import FooterComponent from "../../component/FooterComponent";
// // import { RoundError } from "../../svg";
// // import { useNavigate } from "react-router-dom";

// // const PaymentFailed = () => {
// //     const navigate = useNavigate();

// //     const styles = {
// //         container: {
// //             fontFamily: "'Arial', sans-serif",
// //             display: "flex",
// //             flexDirection: "column",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             backgroundColor: "#f8f9fa",
// //             color: "#1D2026",
// //             height: "100vh",
// //             padding: "20px",
// //             textAlign: "center",
// //         },
// //         contentWrapper: {
// //             backgroundColor: "#fff",
// //             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
// //             borderRadius: "12px",
// //             padding: "30px",
// //             width: "500px",
// //             maxWidth: "90%",
// //         },
// //         icon: {
// //             fontSize: "50px",
// //             color: "#DC3545",
// //             marginBottom: "15px",
// //         },
// //         title: {
// //             fontSize: "24px",
// //             fontWeight: "bold",
// //             color: "#DC3545",
// //             marginBottom: "10px",
// //         },
// //         message: {
// //             fontSize: "16px",
// //             color: "#6c757d",
// //             marginBottom: "20px",
// //             lineHeight: "1.6",
// //         },
// //         bankDetails: {
// //             textAlign: "left",
// //             marginTop: "20px",
// //         },
// //         bankDetailItem: {
// //             fontSize: "14px",
// //             marginBottom: "8px",
// //         },
// //         button: {
// //             fontSize: "16px",
// //             color: "#fff",
// //             backgroundColor: "#007BFF",
// //             border: "none",
// //             padding: "12px 24px",
// //             borderRadius: "4px",
// //             cursor: "pointer",
// //             textDecoration: "none",
// //             transition: "background-color 0.3s",
// //             margin: "10px 5px",
// //         },
// //         buttonHover: {
// //             backgroundColor: "#0056b3",
// //         },
// //     };

// //     return (
// //         <div style={styles.container}>
// //           fkvhskfskvksnjkdnk
// //             <div style={styles.contentWrapper}>
// //                 <div style={styles.icon}>
// //                     <RoundError />
// //                 </div>
// //                 <div style={styles.title}>Payment Failed</div>
// //                 <p style={styles.message}>
// //                     We couldn’t process your payment. If money has been deducted from
// //                     your account, please press the button below to request a review
// //                     from the server.
// //                 </p>
// //                 <div style={styles.bankDetails}>
// //                     <div style={styles.bankDetailItem}><strong>Account Number:</strong> 56481254789412</div>
// //                     <div style={styles.bankDetailItem}><strong>Holder Name:</strong> Kingster</div>
// //                     <div style={styles.bankDetailItem}><strong>Bank Name:</strong> State Bank of India</div>
// //                     <div style={styles.bankDetailItem}><strong>IFSC Code:</strong> SBI0000</div>
// //                 </div>
// //                 <div>
// //                     <button
// //                         style={styles.button}
// //                         onClick={() => alert("Requesting review from the server...")}
// //                         onMouseOver={(e) => e.target.style.backgroundColor = styles.buttonHover.backgroundColor}
// //                         onMouseOut={(e) => e.target.style.backgroundColor = styles.button.backgroundColor}
// //                     >
// //                         Request Review
// //                     </button>
// //                     <button
// //                         style={styles.button}
// //                         onClick={() => navigate("/courses/Courses")}
// //                         onMouseOver={(e) => e.target.style.backgroundColor = styles.buttonHover.backgroundColor}
// //                         onMouseOut={(e) => e.target.style.backgroundColor = styles.button.backgroundColor}
// //                     >
// //                         Back to Home
// //                     </button>
// //                 </div>
// //             </div>
// //             <FooterComponent />
// //         </div>
// //     );
// // };

// // export default PaymentFailed;


import React, { useState } from "react";
import FooterComponent from "../../component/FooterComponent";
import { RoundError } from "../../svg";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./PaymentFailed.module.css";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { CircularProgress } from "@mui/material";



const PaymentFailed = () => {
  const navigate = useNavigate();
  const {id}=useParams()
  const [loading,setLoading]=useState(false)

//   const styles = {
//     container: {
//       fontFamily: "'Arial', sans-serif",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       textAlign: "center",
//       backgroundColor: "#FFFFFF",
//       color: "#1D2026",
//       height: "100%",
//       // padding: "20px",
//     },
//     contentWrapper: {
//       border: "1px solid #D3D3D3",
//       borderRadius: "8px",
//       padding: "20px",
//       marginTop:"20px",

//       width: "700px",
//       maxWidth: "100%",
//       boxSizing: "border-box",
//     },
//     icon: {
//       fontSize: "50px",
//       color: "#DC3545",
//       marginBottom: "10px",
//     },
//     title: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       color: "#DC3545",
//       marginBottom: "10px",
//     },
//     message: {
//       fontSize: "15px",
//       color: "#6E7485",
//       marginBottom: "20px",
//       lineHeight: "1.5",
//       whiteSpace: "normal",
//     },
//     divider: {
//       width: "100%",
//       height: "1px",
//       backgroundColor: "#D3D3D3",
//       marginTop: "40px",
//     },
//     bankDetailsContainer: {
//       textAlign: "left",
//       paddingTop: "40px",
//       marginBottom: "20px",
//     },
//     bankDetailsHeading: {
//       fontSize: "18px",
//       fontWeight: "bold",
//       marginBottom: "20px",
//     },
//     detailRow: {
//       display: "flex",
//       justifyContent: "space-between",
//       fontSize: "16px",
//       marginBottom: "20px",
//     },
//     label: {
//       color: "#6E7485",
//     },
//     value: {
//       color: "#000000",
//     },
//     button: {
//       fontSize: "18px",
//       color: "#FFFFFF",
//       backgroundColor: "#007BFF",
//       border: "none",
//       padding: "15px 30px",
//       borderRadius: "4px",
//       cursor: "pointer",
//       textDecoration: "none",
//       transition: "background-color 0.3s",
//       flex: 1, // Ensures both buttons take equal width
//       marginTop: "10px", // Adds space between buttons
//     },
//     tryAgainButton: {
//       backgroundColor: "#28A745", // Green color for 'Try Again'
//     },
//     buttonContainer: {
//       display: "flex",
//       justifyContent: "space-between",
//       gap: "20px", // Adds gap between buttons
//       width: "600px", // Matches the contentWrapper width
//       marginTop: "20px",
//       flexWrap: "wrap", // Allows buttons to stack on smaller screens
//     },
//     "@media (max-width: 1024px)": {
//       contentWrapper: {
//         width: "80%",
//       },
//       title: {
//         fontSize: "22px",
//       },
//       message: {
//         fontSize: "15px",
//       },
//       button: {
//         padding: "13px 28px",
//         fontSize: "17px",
//       },
//     },
//     "@media (max-width: 768px)": {
//       contentWrapper: {
//         width: "90%",
//       },
//       title: {
//         fontSize: "20px",
//       },
//       message: {
//         fontSize: "14px",
//       },
//       button: {
//         padding: "12px 25px",
//         fontSize: "16px",
//       },
//     },
//       "@media (max-width: 480px)": {
//   container: {
//     padding: "15px",
//   },
//   contentWrapper: {
//     padding: "15px",
//   },
//   title: {
//     fontSize: "18px",
//   },
//   message: {
//     fontSize: "14px",
//   },
//   button: {
//     padding: "12px 20px",
//     fontSize: "16px",
//     width: "100%", 
//     boxSizing: "border-box", 
//     marginBottom: "10px",
//   },
//   buttonContainer: {
//     display: "flex",
//     flexDirection: "column", // Stack buttons vertically
//     alignItems: "center",
//     width: "300px", 
//   },
// },

//   };

console.log(id,"course id");

  const handleTryAgain = async() => {
    try {
      setLoading(true)
      const {data,status}=await api.getPaymentStatus({courseId:id})
      if(status === 200){
        Toastify.success(`Reverification success`)
        navigate(`/courses/Courses/CourseDetails/CoursesVideos/${id}`)
      }
      return
    } catch (error) {
      Toastify.error(error.response.data.message);
      console.log(error);
      

    }
    finally{
      setLoading(false)
    }
    
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.icon}>
            <RoundError />
          </div>
          <div className={styles.title}>PAYMENT FAILED</div>
          <p className={styles.message}>
            Unable to complete your transaction due to a technical issue! Please
            try again using another form of payment as the bank details of the
            seller are given below.
            <span  className={styles.message_success} >
            If money has been deducted from your account, please press the button below to request a review
            from the server.
            </span>
          </p>
          <div className={styles.divider}></div>
          <div className={styles.bankDetailsContainer}>
            <div className={styles.bankDetailsHeading}>Bank details</div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Account number</span>
              <span className={styles.value}>56481254789412</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Holder name</span>
              <span className={styles.value}>Kingster</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Bank name</span>
              <span className={styles.value}>State Bank of India</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>IFSC Code</span>
              <span className={styles.value}>SBI0000</span>
            </div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <a
            href="/courses/Courses"
            className={styles.button}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#000000")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
          >
            Back To Home
          </a>

          <button
            className={`${styles.button} ${styles.tryAgainButton}`}
            onClick={handleTryAgain}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#28A745")}
          >
            {loading?<CircularProgress color="white"/>:`Request Review`}
            
          </button>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};

export default PaymentFailed;

